import { I18nComponente } from "@/types/gerais"

export const OEditarPlanejamentoAtividadei18n: I18nComponente = {
  "pt-BR": {
    editarAtividade: "editar atividade",
    codDaAtividadePlanejada: "cód. da atividade planejada:",
    dataDeInicio: "data de inicio",
    dataDeFim: "data de fim",
    horarioDeInicio: "horário de inicio",
    duracaoMinutos: "duração (minutos)",
    naoRepete: "não repete",
    ate: "até",
    repetirNosDias: "repetir nos dias:",
    repeteSemanalmente: "repete semanalmente",
    repeticao: "repetição",
    fimDaRepeticao: "fim da repetição",
    cancelar: "cancelar",
    salvar: "salvar",
    salvarEdicoes: "salvar edições",
    salvarEdicoesNaAtividadePlanejada: "salvar edições na atividade planejada?",
    carregandoDados: "carregando dados",
    atividadePlanejadaLancadaComSucesso: "Atividade planejada lançada com sucesso",
    naoFoiPossivelLancarAtividade: "Não foi possível lançar a atividade",
    calendarioDaAtividadeCriadoComSucesso: "Calendário da atividade criado com sucesso",
    naoFoiPossivelCriarCalendarioDaAtividade: "Não foi possível criar o calendário da atividade",
    profissionaisAlocados: "profissionais alocados*",
    peloMenosUmDiaDeveSerSelecionado: "pelo menos um dia deve ser selecionado*",
    dataDeInicioObrigatoria: "data de inicio é obrigatória*",
    horarioDeInicioObrigatoria: "horario de inicio é obrigatória*",
    editarSomenteEstaAtividade: "editar somente esta atividade",
    editarEstaAtividadeAsSeguintes: "editar esta atividade e as seguintes",
    editarTodasAsAtividades: "editar todas as atividades",
    edicoesSalvas: "Edições salvas!",
    vaoAparecerNoCalendarioEmInstantas: "Vão aparecer no calendário em instantes",
    tenteNovamenteMaisTarde: "Tente novamente mais tarde.",
    ocorreuUmErroAoSalvarAsEdicoes: "Ocorreu um erro ao salvar as edições.",
    ocorreuUmErroAoBuscarListaDeProfissionais: "Ocorreu um erro ao buscar a lista de profissionais.",
    ocorreuUmErroAoBuscarAsInformacoesDoCalendario: "Ocorreu um erro ao buscar as informações do calendário.",
    ocorreuUmErroAoCarregarOsDados: "Ocorreu um erro ao carregar os dados.",
  },
  "es-CO": {
    editarAtividade: "editar actividad",
    codDaAtividadePlanejada: "cód. de la actividad planeada:",
    dataDeInicio: "fecha de inicio",
    dataDeFim: "fecha de fin",
    horarioDeInicio: "hora de inicio",
    duracaoMinutos: "duración (minutos)",
    naoRepete: "no se repite",
    ate: "hasta",
    repetirNosDias: "repetir en los días:",
    repeteSemanalmente: "se repite semanalmente",
    repeticao: "repetición",
    fimDaRepeticao: "fin de la repetición",
    cancelar: "cancelar",
    salvar: "guardar",
    salvarEdicoes: "guardar ediciones",
    salvarEdicoesNaAtividadePlanejada: "guardar ediciones en la actividad planeada?",
    carregandoDados: "cargando datos",
    atividadePlanejadaLancadaComSucesso: "Actividad planeada lanzada con éxito",
    naoFoiPossivelLancarAtividade: "No fue posible lanzar la actividad",
    calendarioDaAtividadeCriadoComSucesso: "Calendario de la actividad creado con éxito",
    naoFoiPossivelCriarCalendarioDaAtividade: "No fue posible añadir el calendario de la actividad",
    profissionaisAlocados: "profesionales asignados*",
    peloMenosUmDiaDeveSerSelecionado: "se debe seleccionar al menos un día*",
    dataDeInicioObrigatoria: "fecha de inicio es obligatoria*",
    horarioDeInicioObrigatoria: "hora de inicio es obligatoria*",
    editarSomenteEstaAtividade: "editar solo esta actividad",
    editarEstaAtividadeAsSeguintes: "editar esta actividad y las siguientes",
    editarTodasAsAtividades: "editar todas las actividades",
    edicoesSalvas: "¡Ediciones guardadas!",
    vaoAparecerNoCalendarioEmInstantas: "Aparecerán en el calendario en instantes",
    tenteNovamenteMaisTarde: "Inténtalo de nuevo más tarde.",
    ocorreuUmErroAoSalvarAsEdicoes: "Se produjo un error al guardar las ediciones.",
    ocorreuUmErroAoBuscarListaDeProfissionais: "Se produjo un error al buscar la lista de profesionales.",
    ocorreuUmErroAoBuscarAsInformacoesDoCalendario: "Se produjo un error al buscar la información del calendario.",
    ocorreuUmErroAoCarregarOsDados: "Se produjo un error al cargar los datos.",
  },
}
